import { CREATE_NOTE, DELETE_NOTE, NOTES_EVENTS, UPDATE_NOTE } from "../reducers/notes-reducer";
import notesService from "../services/notesService";

//#region Create Note
const createNoteStart = () => {
    return {
        event: NOTES_EVENTS.CREATE_NOTE,
        type: CREATE_NOTE.START,
    };
};

const createNoteSuccess = (data) => {
    return {
        event: NOTES_EVENTS.CREATE_NOTE,
        type: CREATE_NOTE.SUCCESS,
        payload: data,
    };
};

const createNoteError = (error) => {
    return {
        event: NOTES_EVENTS.CREATE_NOTE,
        type: CREATE_NOTE.ERROR,
        payload: error,
    };
};

export const createNote = (req) => async (dispatch) => {
    dispatch(createNoteStart());
    notesService
        .createNoteService(req)
        .then((response) => {
            dispatch(createNoteSuccess(response));
        })
        .catch((error) => {
            dispatch(createNoteError(error));
        });
};

//#endregion Create Note

//#region Update Note
const updateNoteStart = () => {
    return {
        event: NOTES_EVENTS.UPDATE_NOTE,
        type: UPDATE_NOTE.START,
    };
};

const updateNoteSuccess = (data) => {
    return {
        event: NOTES_EVENTS.UPDATE_NOTE,
        type: UPDATE_NOTE.SUCCESS,
        payload: data,
    };
};

const updateNoteError = (error) => {
    return {
        event: NOTES_EVENTS.UPDATE_NOTE,
        type: UPDATE_NOTE.ERROR,
        payload: error,
    };
};

export const updateNote = (req) => async (dispatch) => {
    dispatch(updateNoteStart());
    notesService
        .updateNoteService(req)
        .then((response) => {
            dispatch(updateNoteSuccess(response));
        })
        .catch((error) => {
            dispatch(updateNoteError(error));
        });
};

//#endregion Update Note

//#region Delete Note
const deleteNoteStart = () => {
    return {
        event: NOTES_EVENTS.DELETE_NOTE,
        type: DELETE_NOTE.START,
    };
};

const deleteNoteSuccess = (data) => {
    return {
        event: NOTES_EVENTS.DELETE_NOTE,
        type: DELETE_NOTE.SUCCESS,
        payload: data,
    };
};

const deleteNoteError = (error) => {
    return {
        event: NOTES_EVENTS.DELETE_NOTE,
        type: DELETE_NOTE.ERROR,
        payload: error,
    };
};

export const deleteNote = (req) => async (dispatch) => {
    dispatch(deleteNoteStart());
    notesService
        .deleteNoteService(req)
        .then((response) => {
            dispatch(deleteNoteSuccess(response));
        })
        .catch((error) => {
            dispatch(deleteNoteError(error));
        });
};

//#endregion Delete Note

//#region Set NoteList Data
export const setNotesList = (data) => {
    return {
        event: NOTES_EVENTS.SET_NOTES_LIST,
        type: "SET_NOTES_LIST",
        payload: data,
    };
};

//#endregion NoteList Data
